import { render, staticRenderFns } from "./Are.vue?vue&type=template&id=40dfa58c&"
import script from "./Are.vue?vue&type=script&lang=js&"
export * from "./Are.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports